/**************************************************
 * Nombre: Propuesta_Valor_Portada_Documentacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Propuesta_Valor_Portada_Documentacion = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        color: 'white',
                        fontSize: sCell ? 32 : 54,
                        fontWeight: 900,
                        textAlign: sCell ? 'center' : 'flex-start',
                        width: "100%",
                        lineHeight: 1.1
                    }}>
                    DOCUMENTACION Y
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: sCell ? 32 : 54,
                            fontWeight: 900,
                            textAlign: {xs: 'center', sm: 'left', md: 'left'},
                            width: "100%",
                            lineHeight: 1.1
                        }}
                    >
                        REPORTES
                    </Typography>
                </Typography>
            </Grid2>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        textAlign: sCell ? 'center' : 'flex-start',
                        fontSize: 18,
                        color: 'white',
                        pt: 2
                    }}>
                    En Fundhap, presentamos informes detallados que exponen con claridad y exactitud nuestra labor y el
                    uso de los recursos financieros. Motivados por un compromiso firme con la responsabilidad y la
                    transparencia, garantizamos acceso a información verificada y al día. Así, nuestros aliados y
                    colaboradores pueden confiar plenamente en nuestra gestión y en el alcance de nuestras metas
                    institucionales.
                </Typography>
            </Grid2>


        </Grid2>
    )

}
export default Propuesta_Valor_Portada_Documentacion;